export const BARS = [
  {
    id: 'tapas',
    category_en: 'The Best Tapas',
    category_es: 'Las Mejores Tapas',
    name: 'El Rincón Ibérico',
    description_en: 'Authentic flavors, imported cured meats, and the finest patatas bravas in town. A standard-setter for traditional Spanish small plates.',
    description_es: 'Sabores auténticos, embutidos de importación y las mejores patatas bravas de la ciudad. Un referente para el tapeo tradicional español.',
    image: 'https://images.unsplash.com/photo-1600891964599-f61ba0e24092?auto=format&fit=crop&q=80&w=1200',
    address: 'Carrer de Nemesi Valls, 15, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 937 123 456',
    menu: [
      {
        name: 'Patatas Bravas',
        desc_en: 'Triple-cooked, spicy brava sauce, garlic aioli',
        desc_es: 'Patatas de triple cocción, salsa brava picante y alioli de ajo',
        price: '€6.50'
      },
      {
        name: 'Jamón Ibérico de Bellota',
        desc_en: 'Acorn-fed, 36 months cured, served with crystal bread',
        desc_es: 'Alimentado con bellota, 36 meses de curación, servido con pan de cristal',
        price: '€24.00'
      },
      {
        name: 'Croquetas de Jamón',
        desc_en: 'Creamy bechamel, crispy shell, ibérico ham',
        desc_es: 'Bechamel cremosa, rebozado crujiente y jamón ibérico',
        price: '€8.00'
      },
      {
        name: 'Pimientos de Padrón',
        desc_en: 'Blistered padrón peppers, flaky sea salt',
        desc_es: 'Pimientos de Padrón asados con escamas de sal marina',
        price: '€6.00'
      },
      {
        name: 'Pulpo a la Gallega',
        desc_en: 'Tender octopus, smoked paprika, olive oil, potatoes',
        desc_es: 'Pulpo tierno, pimentón de la Vera, aceite de oliva virgen extra y patatas',
        price: '€16.50'
      }
    ]
  },
  {
    id: 'breakfast',
    category_en: 'The Best Breakfast',
    category_es: 'El Mejor Desayuno',
    name: 'Cozy cup cafe',
    description_en: 'A flawless 5.0-star espresso bar serving the most incredible, hearty breakfasts in town. From classic bacon and eggs to artisan avocado and smoked salmon toasts, this is the ultimate morning destination.',
    description_es: 'Una impecable barra de espresso con 5.0 estrellas que sirve los desayunos más increíbles y contundentes de la ciudad. Desde los clásicos huevos con bacon hasta tostadas artesanales de aguacate y salmón ahumado, este es el destino definitivo para tus mañanas.',
    image: 'https://images.unsplash.com/photo-1493770348161-369560ae357d?auto=format&fit=crop&q=80&w=1200',
    address: 'Passeig del Dr. Moragas, 193, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 631 86 93 91',
    menu: [
      {
        name: 'English Breakfast',
        desc_en: 'Bacon, fried eggs, baked beans, and toast',
        desc_es: 'Bacon, huevos, alubia cocida y pan',
        price: '€7.50'
      },
      {
        name: 'Pancakes',
        desc_en: 'Fluffy pancakes served with crispy bacon and fried eggs',
        desc_es: 'Pancakes con bacon y huevos fritos',
        price: '€7.50'
      },
      {
        name: 'Desayuno París',
        desc_en: 'Ham and cheese croissant, fresh orange juice, and coffee or tea',
        desc_es: 'Croissant jamón y queso, zumo de naranja natural y café o té',
        price: '€4.50'
      },
      {
        name: 'Tostada Payesa',
        desc_en: 'Rustic bread toast with serrano ham, fresh orange juice, and coffee or tea',
        desc_es: 'Tostada de pan de payés con jamón serrano, zumo de naranja natural y café o té',
        price: '€5.50'
      },
      {
        name: 'Granola Bowl',
        desc_en: 'Crunchy granola served with creamy Greek yogurt and fresh mixed fruits',
        desc_es: 'Granola con yogur griego y frutas',
        price: '€5.50'
      },
      {
        name: 'Tostada Nórdica',
        desc_en: 'Smoked salmon, fresh avocado, and Philadelphia cream cheese toast',
        desc_es: 'Tostada de salmón ahumado, aguacate y queso Philadelphia',
        price: '€6.50'
      },
      {
        name: 'Tostada de Escalivada',
        desc_en: 'Traditional roasted eggplant and bell pepper toast',
        desc_es: 'Tostada de escalivada tradicional',
        price: '€4.95'
      }
    ]
  },
  {
    id: 'noodles',
    category_en: 'The Best Noodles',
    category_es: 'Los Mejores Tallarines',
    name: "Bar Cafeteria Ca L' Enric",
    description_en: 'An unassuming local legend. While they offer a full cafeteria menu, their absolute standout dish is the Tallarines a la Plancha—perfectly seared noodles that keep the locals coming back.',
    description_es: 'Una auténtica leyenda local. Aunque ofrecen un menú completo de cafetería, su plato estrella indiscutible son los Tallarines a la Plancha: fideos perfectamente dorados que hacen volver a los vecinos una y otra vez.',
    image: 'https://images.unsplash.com/photo-1552611052-33e04de081de?auto=format&fit=crop&q=80&w=1200',
    address: 'Av. de la Generalitat, 95, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 699 23 23 01',
    menu: [
      {
        name: 'Tallarines a la Plancha',
        desc_en: 'The house specialty: perfectly seared noodles with savory seasoning and local flair.',
        desc_es: 'Nuestra especialidad: fideos perfectamente dorados a la plancha con un toque sabroso y el sello de la casa.',
        price: '€6.00'
      },
      {
        name: 'Copa de Cerveza',
        desc_en: 'Crisp, cold draft beer, the perfect accompaniment to the house noodles.',
        desc_es: 'Cerveza de barril bien fría, el acompañamiento ideal para nuestros tallarines.',
        price: '€2.50'
      },
      {
        name: 'Bocadillo Caliente',
        desc_en: 'Freshly made warm sandwich with a choice of premium local ingredients.',
        desc_es: 'Bocadillo caliente recién hecho con una selección de ingredientes locales de calidad.',
        price: '€4.50'
      }
    ]
  },
  {
    id: 'craftbeer',
    category_en: 'The Best Craft Beer',
    category_es: 'La Mejor Cerveza Artesana',
    name: 'La Barberenca',
    description_en: 'A genuine local craft beer factory and brewpub right in the heart of Barberà. Serving fresh, artisanal beers directly from their taps with a constantly rotating selection.',
    description_es: 'Una auténtica fábrica de cerveza artesanal y brewpub en pleno corazón de Barberà del Vallès. La mejor opción en el Vallès Occidental, a un paso de Barcelona. Sirviendo cervezas frescas y artesanales directamente de sus grifos con una selección en constante rotación.',
    image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1779688358482-blob',
    address: 'Carrer de Nemesi Valls, 24, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 657 68 63 86',
    menu: [
      {
        name: 'FLiPA',
        desc_en: '7% vol | 68 IBUs',
        desc_es: '7% vol | 68 IBUs',
        price: "3'5 € | 4 €"
      },
      {
        name: 'NEIPA',
        desc_en: '6% vol',
        desc_es: '6% vol',
        price: "3'5 € | 4 €"
      },
      {
        name: 'LA LLIBERTARIA',
        desc_en: "GERMAN PILS | 5'6%",
        desc_es: "GERMAN PILS | 5'6%",
        price: "3 € | 3'3 €"
      }
    ]
  },
  {
    id: 'ipa',
    category_en: 'The Best IPA Beers',
    category_es: 'Las Mejores Cervezas IPA',
    name: 'Bar Arjona',
    description_en: 'A sanctuary for hop enthusiasts in Barberà. Featuring a meticulously curated selection of craft IPAs ranging from local microbrews to international legends.',
    description_es: 'Un santuario para los entusiastas del lúpulo en Barberà. Presentamos una selección meticulosamente curada de IPAs artesanales, desde microcervecerías locales hasta leyendas internacionales.',
    image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1778949135234-blob',
    address: 'Av. de la Verge de Montserrat, 39, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 937 111 222',
    menu: [
      {
        name: 'West Coast IPA',
        desc_en: 'Crisp, piney, and citrusy with a bold bitter finish',
        desc_es: 'Fresca, resinosa y cítrica con un final amargo pronunciado',
        price: '€6.00'
      },
      {
        name: 'Hazy New England IPA',
        desc_en: 'Tropical fruit notes, soft mouthfeel, and low bitterness',
        desc_es: 'Notas de frutas tropicales, cuerpo sedoso y amargor sutil',
        price: '€6.50'
      },
      {
        name: 'Double IPA',
        desc_en: 'High ABV, intense hop profile, resinous and powerful',
        desc_es: 'Alto contenido alcohólico, perfil de lúpulo intenso, resinosa y potente',
        price: '€7.50'
      },
      {
        name: 'Session IPA',
        desc_en: 'Light-bodied, easy drinking with full aromatic hop character',
        desc_es: 'Cuerpo ligero, fácil de beber y con todo el carácter aromático del lúpulo',
        price: '€5.00'
      },
      {
        name: 'Spicy Loaded Nachos',
        desc_en: 'The perfect pairing for hoppy beers with jalapeños and cheddar',
        desc_es: 'El maridaje perfecto para cervezas lupuladas con jalapeños y cheddar',
        price: '€9.00'
      }
    ]
  },
  {
    id: 'cocktails',
    category_en: 'The Best Cocktails',
    category_es: 'Los Mejores Cócteles',
    name: 'Velvet & Smoke',
    description_en: 'Sophisticated mixology in a dimly lit, speakeasy-inspired setting. Every drink tells a story of craft and precision.',
    description_es: 'Mixología sofisticada en un ambiente íntimo inspirado en los antiguos speakeasy. Cada cóctel cuenta una historia de artesanía y precisión.',
    image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=1200',
    address: 'Carrer de Pintor Fortuny, 12, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 937 333 444',
    menu: [
      {
        name: 'The Smoked Old Fashioned',
        desc_en: 'Woodford Reserve, aromatic bitters, hickory smoke',
        desc_es: 'Woodford Reserve, bitters aromáticos y humo de nogal',
        price: '€12.00'
      },
      {
        name: 'Velvet Espresso',
        desc_en: 'Grey Goose, fresh espresso, coffee liqueur, vanilla',
        desc_es: 'Grey Goose, espresso recién hecho, licor de café y vainilla',
        price: '€11.00'
      },
      {
        name: 'Botanical Gin Fizz',
        desc_en: 'Hendricks, elderflower, cucumber, lemon, soda',
        desc_es: 'Hendricks, flor de saúco, pepino, limón y soda',
        price: '€10.50'
      },
      {
        name: 'Spicy Mezcalita',
        desc_en: 'Montelobos Mezcal, agave, lime, jalapeño, tajin rim',
        desc_es: 'Mezcal Montelobos, agave, lima, jalapeño y borde de tajín',
        price: '€13.00'
      }
    ]
  },
  {
    id: 'pint',
    category_en: 'The Best Pint',
    category_es: 'La Mejor Pinta',
    name: 'The Copper Keg',
    description_en: 'The definitive spot for beer enthusiasts. From perfectly settled stouts to refreshing local craft ales.',
    description_es: 'El lugar definitivo para los amantes de la cerveza. Desde stouts perfectamente servidas hasta refrescantes ales artesanales locales.',
    image: 'https://images.unsplash.com/photo-1532634922-8fe0b757fb13?auto=format&fit=crop&q=80&w=1200',
    address: 'Plaça de la Vila, 1, 08210 Barberà del Vallès, Barcelona',
    phone: '+34 937 555 666',
    menu: [
      {
        name: 'Guinness Stout',
        desc_en: 'The gold standard, poured with the legendary two-part settle',
        desc_es: 'El estándar de oro, servida con el legendario reposo en dos tiempos',
        price: '€5.50'
      },
      {
        name: 'Local IPA',
        desc_en: 'Hoppy, citrus notes, brewed 5 miles away in the valley',
        desc_es: 'Lupulada, notas cítricas, elaborada a pocos kilómetros en el valle',
        price: '€6.00'
      },
      {
        name: 'Belgian Witbier',
        desc_en: 'Wheat beer, coriander, orange peel, crisp finish',
        desc_es: 'Cerveza de trigo, cilantro, piel de naranja y final refrescante',
        price: '€5.00'
      },
      {
        name: 'Artisan Cider',
        desc_en: 'Dry, crisp apple cider from the northern orchards',
        desc_es: 'Sidra de manzana seca y crujiente de los huertos del norte',
        price: '€4.50'
      },
      {
        name: 'Soft Pretzel',
        desc_en: 'Warm salted pretzel, house beer cheese dip',
        desc_es: 'Pretzel caliente con sal, acompañado de crema de queso a la cerveza de la casa',
        price: '€4.00'
      }
    ]
  }
];